import React from "react"
import { Divider } from "@mui/material"
import Typography from "@mui/material/Typography"

const Header = (props) => (
	<div className="header">
		<br></br>
		<Typography variant="h2" textAlign="center">
			{props.title}
		</Typography>
		<br></br>
		<Divider />
	</div>
)

export default Header
